<template>
  <div id="app">
    <!-- GOOGLE TAG MANAGER -->
    <template v-if="env === 'dev'">
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-5CB7L6N"
          height="0"
          width="0"
          style="display:none;visibility:hidden"
        ></iframe>
      </noscript>
    </template>

    <template v-if="env === 'prod'">
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-TF8ZX5R"
          height="0"
          width="0"
          style="display:none;visibility:hidden"
        ></iframe>
      </noscript>
    </template>

    <template v-if="env === 'teste'">
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-TFXVML2"
          height="0"
          width="0"
          style="display:none;visibility:hidden"
        ></iframe>
      </noscript>
    </template>

    <router-view />
 
    <Modal v-for="(modal,i) in modals" :key="'modal'+i" :modal="modal" />
  </div>
  
</template>

<script>
import { env } from "./conf/conf.js";
import { mapGetters } from "vuex";
import Modal from "@/components/Modal.vue";

export default {
  name: "App",
  components: { Modal },
  data() {
    return { env: env };
  },
    computed: {
    ...mapGetters("general", ["modals"]),
    
  }
};
</script>
